import styled from "styled-components";

export const Container = styled.div`
  padding: 4px 8px;
  color: #1F2937;
  font-family: 'Mukta Vaani', 'Inter', sans-serif;
`;

export const Header = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.01em;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: #6B7280;
  line-height: 1.5;
`;

export const ExplainerCard = styled.div`
  background: #EEF2FF;
  border: 1px solid #C7D2FE;
  border-radius: 12px;
  padding: 18px 22px;
  margin-bottom: 28px;
`;

export const ExplainerTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #3730A3;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

export const ExplainerBody = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #1F2937;

  code {
    background: rgba(79, 70, 229, 0.12);
    color: #3730A3;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 15px;
    font-family: ui-monospace, 'SF Mono', monospace;
    font-weight: 600;
  }
`;

export const ExplainerList = styled.ul`
  margin: 10px 0 0;
  padding-left: 20px;
  font-size: 16px;
  line-height: 1.7;
  color: #1F2937;
`;

export const Section = styled.div`
  margin-bottom: 28px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.005em;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  overflow: hidden;
  font-size: 16px;

  thead {
    background: #F9FAFB;
  }

  th, td {
    padding: 12px 16px;
    border-bottom: 1px solid #F3F4F6;
    text-align: left;
    color: #1F2937;
    vertical-align: middle;
  }

  th {
    font-size: 13.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6B7280;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #F9FAFB;
  }

  tbody tr.highlight {
    background: #FEF3C7;
    font-weight: 600;
  }

  tbody tr.highlight:hover {
    background: #FEF3C7;
  }

  tbody td.numeric {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
  }
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  background: ${p => p.variant === 'investment' ? '#ECFDF5' : p.variant === 'high-yield' ? '#FEF3C7' : '#EEF2FF'};
  color: ${p => p.variant === 'investment' ? '#047857' : p.variant === 'high-yield' ? '#92400E' : '#3730A3'};
`;

export const Footnote = styled.p`
  margin: 12px 4px 0;
  font-size: 14.5px;
  color: #6B7280;
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/components/bcase/ExhibitLayout.js